import { render } from "./PackageCard.vue?vue&type=template&id=f9cc5658"
import script from "./PackageCard.vue?vue&type=script&lang=js"
export * from "./PackageCard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__